import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=5c04ef5b"
import script from "./EditMessage.vue?vue&type=script&lang=js"
export * from "./EditMessage.vue?vue&type=script&lang=js"
import style0 from "../../scss/base.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports